<template>
	<div class="container">
		<div class="content">
			<h2 class="mb_15">{{ $t('merchant.title6') }}</h2>
			<div class="card mb_0">
				<h3 class="title mb_15">{{ $t('merchant.menu_2.menu6') }}</h3>
				<div class="email">
					<security-info />
					<div class="d_flex">
						<input
							type="email"
							:placeholder="$t('input.placeholder.email')"
							:value="member_info.email_address"
							class="flex_grow mr_5"
							disabled
						/>
						<button
							class="button_bg_red code_send"
							@click="sendVerificationCode"
						>
							{{ $t('button.code') }}
						</button>
					</div>

					<div v-if="token" class="mt_20">
						<div class="d_flex">
							<div class="timer">{{ time }}</div>
							<input
								type="text"
								:placeholder="$t('input.placeholder.code_request')"
								style="border-radius: 0 10px 10px 0"
							/>
						</div>
						<div class="link_code_send">
							<a class="fc_red" @click="sendVerificationCode">{{
								$t('merchant.email.link1')
							}}</a>
						</div>
						<button class="button_bg_red" @click="checkVerificationCode">
							{{ $t('button.code_check') }}
						</button>
					</div>
				</div>
			</div>
		</div>
		<div class="info_area">
			<div>
				<p>{{ $t('banner2.text1') }}</p>
				<span>10:00-19:00 {{ $t('banner2.text2') }}</span>
			</div>
			<div class="partition">
				<p>{{ $t('banner2.text3') }}</p>
				<span>{{ $t('banner2.text4') }} {{ $t('banner2.text5') }}</span>
			</div>
			<div>
				<p>{{ $t('banner2.text6') }}</p>
				<span>10:00 - 19:00 {{ $t('banner2.text7') }}</span>
			</div>
		</div>
	</div>
</template>

<script>
import SecurityInfo from '@/components/Merchant/Certification/SecurityInfo';
import { mapGetters } from 'vuex';
import { createVerification, createVerificationToken } from '@/api/mail';
import { commonError } from '@/common/dialog';
export default {
	name: 'Email.m',
	components: { SecurityInfo },
	data() {
		return {
			token: null,
			timer: null,
			time: '05:00',
			time_remaining: 0,
		};
	},
	computed: {
		...mapGetters('auth', ['member_info']),
	},
	methods: {
		async sendVerificationCode() {
			const { token } = await createVerificationToken().catch(commonError);
			this.token = token;
			this.startTimer();
		},
		async checkVerificationCode() {
			const { token } = await createVerification({ token: token }).catch(
				commonError,
			);
			this.resetTimer();
		},
		startTimer() {
			clearInterval(this.timer);
			this.time_remaining = 300;
			this.timer = setInterval(() => {
				this.updateTimer();
			}, 1000);
		},
		resetTimer() {
			clearInterval(this.timer);
			this.token = null;
			this.time = '05:00';
		},
		updateTimer() {
			if (this.time_remaining === 0) return this.resetTimer();
			this.time_remaining--;
			const minute = '0' + Math.floor(this.time_remaining / 60);
			const seconds =
				this.time_remaining % 60 < 10
					? '0' + (this.time_remaining % 60)
					: this.time_remaining % 60;
			this.time = minute + ':' + seconds;
		},
	},
};
</script>
